import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3 4.5L6 7.5L9 4.5" })
});
export default SvgChevronDown;
